import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { MilestoneMapInterval } from '@mm-shared/types/MilestoneMap1';

/**
 * Selects the current zoom level from Redux state
 * Returns null if no zoom level is set (use map default)
 */
export const selectCurrentZoomLevel = (state: RootState): MilestoneMapInterval | null => {
  return state.map3UI.mapControls.zoomLevel;
};

/**
 * Selects the effective zoom level for a given map
 * Falls back to the map's base interval if no zoom level is set
 *
 * @param mapInterval - The map's base interval to use as fallback
 */
export const selectEffectiveZoomLevel = createSelector(
  [selectCurrentZoomLevel, (_state: RootState, mapInterval: MilestoneMapInterval) => mapInterval],
  (currentZoomLevel, mapInterval): MilestoneMapInterval => {
    return currentZoomLevel ?? mapInterval;
  }
);
